import { applicationName } from 'enum/application.enum';
import type { _User } from 'models/user';
import { mock } from 'utils/axios';

const users: _User[] = [
  {
    id: '1',
    fullName: 'Rafael Kunde',
    avatar: '/static/images/avatars/1.jpg',
    email: 'Monte.Auer31@yahoo.com',
    jobTitle: 'Product Infrastructure Associate',
    externalId: 'Delphia22',
    location: 'Gislasonchester',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/1.jpg',
    application: 'BACKOFFICE',
    cpf: '12345678900',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
    followers: '667',
    description:
      'Vestibulum rutrum rutrum neque. Aenean auctor gravida sem quam pede lobortis ligula, sit amet eleifend.',
    posts: '8',
  },
  {
    id: '2',
    fullName: 'Madeline Pagac',
    avatar: '/static/images/avatars/2.jpg',
    email: 'Francis64@gmail.com',
    jobTitle: 'Internal Configuration Planner',
    externalId: 'Odessa_Goodwin38',
    location: 'Flaviomouth',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/2.jpg',
    followers: '375',
    description:
      'Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci.',
    posts: '11',
    application: 'BACKOFFICE',
    cpf: '12345678900',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '3',
    fullName: 'Okey Turner V',
    avatar: '/static/images/avatars/3.jpg',
    email: 'Alexys.Frami91@hotmail.com',
    jobTitle: 'Regional Division Analyst',
    externalId: 'Ross_Reichert',
    location: 'Derekmouth',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/3.jpg',
    followers: '6333',
    description:
      'Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque. Quisque porta volutpat erat.',
    posts: '23',
    application: 'BACKOFFICE',
    cpf: '12345678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '4',
    fullName: 'Modesta Sauer',
    avatar: '/static/images/avatars/4.jpg',
    email: 'Susan_Wolff@hotmail.com',
    jobTitle: 'Lead Communications Consultant',
    externalId: 'Sincere46',
    location: 'Josieview',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/4.jpg',
    followers: '1876',
    description: 'Phasellus in felis. Donec semper sapien a libero. Nam dui.',
    posts: '362',
    application: 'PARTNER',
    cpf: '12345678907',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '5',
    fullName: 'Oma Bogisich',
    avatar: '/static/images/avatars/5.jpg',
    email: 'Demetris88@hotmail.com',
    jobTitle: 'Customer Implementation Strategist',
    externalId: 'Prince.Bergnaum',
    location: 'East Alexander',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/5.jpg',
    followers: '6513',
    description:
      'Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum.',
    posts: '94',
    application: 'BACKOFFICE',
    cpf: '12345678955',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '6',
    fullName: 'Wade Heathcote',
    avatar: '/static/images/avatars/1.jpg',
    email: 'Elissa.Ortiz50@hotmail.com',
    jobTitle: 'Regional Markets Assistant',
    externalId: 'Camylle.Nicolas33',
    location: 'Gaetanoside',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/6.jpg',
    followers: '492',
    description:
      'Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.',
    posts: '38',
    application: 'BACKOFFICE',
    cpf: '12345678916',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '7',
    fullName: 'Dan Stroman',
    avatar: '/static/images/avatars/2.jpg',
    email: 'Amaya53@yahoo.com',
    jobTitle: 'Internal Configuration Facilitator',
    externalId: 'Alfonzo.Ruecker96',
    location: 'Reginaldbury',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/1.jpg',
    followers: '3848',
    description: 'Vivamus tortor. Duis mattis egestas metus.',
    posts: '4',
    application: 'BACKOFFICE',
    cpf: '12345678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '8',
    fullName: 'Delta Wiza',
    avatar: '/static/images/avatars/3.jpg',
    email: 'Amari.Gaylord42@hotmail.com',
    jobTitle: 'International Division Specialist',
    externalId: 'Mozelle_Bernier',
    location: 'East Bill',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/2.jpg',
    followers: '730',
    description:
      'Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.',
    posts: '457',
    application: 'PARTNER',
    cpf: '12345678932',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '9',
    fullName: 'Edwina Collins',
    avatar: '/static/images/avatars/4.jpg',
    email: 'Shaina.Beahan@yahoo.com',
    jobTitle: 'Investor Quality Executive',
    externalId: 'Wendy_Weissnat',
    location: 'Zboncakchester',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/3.jpg',
    followers: '6673',
    description:
      'Vestibulum rutrum rutrum neque. Aenean auctor gravida sem. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id.',
    posts: '237',
    application: 'BACKOFFICE',
    cpf: '12345678982',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '10',
    fullName: 'Ms. Antoinette Dicki',
    avatar: '/static/images/avatars/5.jpg',
    email: 'Yadira68@gmail.com',
    jobTitle: 'Direct Integration Facilitator',
    externalId: 'Jayde_Grant28',
    location: 'Murphyberg',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/4.jpg',
    followers: '980',
    description:
      'Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo. Maecenas pulvinar lobortis est. Phasellus sit amet erat.',
    posts: '84',
    application: 'PARTNER',
    cpf: '12345610902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '11',
    fullName: 'Ewald Spinka',
    avatar: '/static/images/avatars/1.jpg',
    email: 'Alexandro_Marquardt@yahoo.com',
    jobTitle: 'Lead Assurance Consultant',
    externalId: 'Guiseppe.Kemmer23',
    location: 'Grantmouth',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/5.jpg',
    followers: '294',
    description:
      'Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem. Fusce consequat.',
    posts: '55',
    application: 'BACKOFFICE',
    cpf: '12398678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '12',
    fullName: 'Tatyana Hudson DVM',
    avatar: '/static/images/avatars/2.jpg',
    email: 'Mckayla12@yahoo.com',
    jobTitle: 'National Brand Representative',
    externalId: 'Ransom.Welch55',
    location: 'Port Royce',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/6.jpg',
    followers: '672',
    description:
      'Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque. Quisque porta volutpat erat.',
    posts: '23',
    application: 'BACKOFFICE',
    cpf: '12345675202',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '13',
    fullName: 'Gregorio Muller',
    avatar: '/static/images/avatars/3.jpg',
    email: 'Katheryn.Casper89@yahoo.com',
    jobTitle: 'Investor Division Planner',
    externalId: 'Jairo_Cartwright58',
    location: 'South Creola',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/1.jpg',
    followers: '893',
    description:
      'Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat. Curabitur gravida nisi at nibh.',
    posts: '465',
    application: 'PARTNER',
    cpf: '12995678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '14',
    fullName: 'Elnora Harris',
    avatar: '/static/images/avatars/4.jpg',
    email: 'Alysha27@yahoo.com',
    jobTitle: 'Human Assurance Administrator',
    externalId: 'Jacinto75',
    location: 'Mayerburgh',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/2.jpg',
    followers: '995',
    description:
      'Nulla tellus. In sagittis dui vel nisl. Duis ac nibh. Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus.',
    posts: '65',
    application: 'BACKOFFICE',
    cpf: '13345678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '15',
    fullName: 'Micheal Jones',
    avatar: '/static/images/avatars/5.jpg',
    email: 'Scot.Koch@gmail.com',
    jobTitle: 'National Applications Engineer',
    externalId: 'Chloe8',
    location: 'Metamouth',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/3.jpg',
    followers: '215',
    description:
      'Proin risus. Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.',
    posts: '9',
    application: 'BACKOFFICE',
    cpf: '12345678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '16',
    fullName: 'Michel Considine',
    avatar: '/static/images/avatars/1.jpg',
    email: 'Cameron.Kuphal50@hotmail.com',
    jobTitle: 'Internal Communications Analyst',
    externalId: 'Quincy_Weimann67',
    location: 'Jayneberg',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/4.jpg',
    followers: '1348',
    description:
      'Aliquam quis turpis eget elit sodales scelerisque. Mauris sit amet eros. Suspendisse accumsan tortor quis turpis.',
    posts: '22',
    application: 'BACKOFFICE',
    cpf: '12345678812',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '17',
    fullName: 'Shayne Cormier',
    avatar: '/static/images/avatars/2.jpg',
    email: 'Buddy96@gmail.com',
    jobTitle: 'National Accounts Analyst',
    externalId: 'Estevan.McGlynn',
    location: 'Lakinburgh',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/5.jpg',
    followers: '9711',
    description:
      'Nulla ac enim. In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem. Duis aliquam convallis nunc. Proin at turpis a pede posuere nonummy.',
    posts: '5',
    application: 'BACKOFFICE',
    cpf: '12735678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '18',
    fullName: 'Doug Goldner',
    avatar: '/static/images/avatars/3.jpg',
    email: 'Tommie.Predovic6@gmail.com',
    jobTitle: 'Human Functionality Orchestrator',
    externalId: 'Veda.Wolff',
    location: 'West Carmellamouth',
    role: 'subscriber',
    coverImg: '/static/images/placeholders/covers/6.jpg',
    followers: '773',
    description:
      'Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl. Aenean lectus. Pellentesque eget nunc.',
    posts: '3',
    application: 'BACKOFFICE',
    cpf: '12345348902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '19',
    fullName: 'Wilhelm Littel',
    avatar: '/static/images/avatars/4.jpg',
    email: 'Reymundo_Gleichner@hotmail.com',
    jobTitle: 'Customer Assurance Administrator',
    externalId: 'Estell_Blick',
    location: 'West Ernestview',
    role: 'admin',
    coverImg: '/static/images/placeholders/covers/1.jpg',
    followers: '650',
    description:
      'Morbi non quam nec dui luctus rutrum. Nulla tellus. In sagittis dui vel nisl.',
    posts: '34',
    application: 'BACKOFFICE',
    cpf: '12349678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
  {
    id: '20',
    fullName: 'Alba Daugherty',
    avatar: '/static/images/avatars/5.jpg',
    email: 'Queen73@yahoo.com',
    jobTitle: 'Customer Accounts Director',
    externalId: 'Ezequiel36',
    location: 'Wizaville',
    role: 'customer',
    coverImg: '/static/images/placeholders/covers/2.jpg',
    followers: '627',
    description:
      'Sed accumsan felis. Ut at dolor quis odio consequat varius. Integer ac leo.',
    posts: '54',
    application: 'PARTNER',
    cpf: '12775678902',
    status: 'active',
    laboratoryId: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
    roles: [
      {
        id: '4c5f5fd4-bc49-420f-9486-b2a3fee02011',
        createdAt: '2025-04-20T21:58:58.330Z',
        updatedAt: '2025-04-20T21:58:58.330Z',
        deletedAt: null,
        createdBy: 'SYSTEM',
        updatedBy: 'SYSTEM',
        roleName: 'ADMINISTRADOR',
        application: applicationName.CLIENT,
        laboratoryId: null,
      },
    ],
  },
];

mock.onGet('/api/users').reply(() => {
  return [200, { users }];
});

mock.onGet('/api/user').reply((config) => {
  const { userId } = config.params;
  const user = users.find((_user) => _user.id === userId);

  return [200, { user }];
});
